import restGql from 'graphql-tag';

export const FetchPlanWarningsQuery = restGql`#graphql
    query FetchPlanWarnings($childId: String!) {
        result(childId: $childId)@rest(type: "FetchPlanWarningsResult", path: "/v2/plans/?version=2&childId={args.childId}&flexiblePackages=true") {
            plans {
                id
                from
                to
                behaviors {
                    id 
                    payload {
                        warnings {
                            title
                            message
                            severity
                            error
                            image
                            metadata {
                                changeFrom
                                invoiceIds
                            }
                        }
                    }
                }
            }
        }
    }
`;
